export enum OrderReturnItemState {
    InReturn = 1,
    InRefund = 2,
    Returned = 3,
    Declined = 4,
}
